// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bOhzB","col":"styles_col__1Kbzq"};